import { PageContent } from "../../pages/templates/PageLayout";

const content: PageContent = {
  style: "darkGradient",
  sections: [
    {
      type: "FormSection",
      title: "Flexibly priced for all types of brands",
      subtitle:
        "Request a quote and see how Lingo's flexible pricing model can work for fortune 500 companies as well as small burgeoning businesses.",
      badge: "Request a quote",
      form: "quote",
      position: { mb: "none", pb: "xxxl" },
    },
    { type: "CustomerLogosSection", position: { mt: "-xl" } },
    { type: "TestimonialSection" },
    {
      type: "CtaSection",
      title: "Build your first kit in 5 minutes or less",
      body: "Organize, store, find, and share your brand assets in one library, from anywhere.",
    },
  ],
};

export default content;
